<template>
  <div v-if="shareQrcode">
    <div class="bc-ps-f share bc-hide" @click="shareClick"><img width="100%" :src='shareQrcode.icon_img' alt=""></div>

    <!--生成日签页面-->
    <bv-layer :show-status="maskIsShow">
      <div class="disease-success bc-c-f">
        <div class="label-area bc-ps-r">
          <!-- 新加的背景图片 -->
          <!-- <img style="width:300px;height:450px" :src="backGround" alt='' /> -->
          <!-- 背景图 -->
          <canvas id="canvas" v-if="!imgSrc" style="border-radius: 12px"></canvas>
          <img id="shareImg" :src="imgSrc" alt="生成日签图片" @click.stop v-else  style="border-radius: 12px" />
          <div class="close-icon" @click="closeMask">
            <img :src="`${config.path.static}/img/home/sign/close_icon.png`" alt='xx关闭' />
          </div>
        </div>
      </div>
    </bv-layer>
  </div>

</template>

<script>
  import signCanvasTmplConfig from "@assets/js/blue-canvas-tmpl-config/disease";
  import BlueCanvasTmpl from 'blue-canvas-tmpl';
  import config from '@config';

  const canvasTmplOpts = {
    el: "#canvas",
    width: 1280,
    height: 2276,
    renderList: []
  };

  export default {
    name: "goods-item",
    data(){
      return{
        // 分享相关
        shareIcon:"",
        shareQrcode:{},
        canvasTmpl: {},
        maskIsShow:false,
        imgSrc:''
      }
    },
    mounted(){
      this.$nextTick(() => {
        this.canvasTmpl = new BlueCanvasTmpl(canvasTmplOpts);
      });
    },
    methods:{
      shareClick(){
        this.canvasTmpl.update(
          this.$utils.extend(
            canvasTmplOpts,
            signCanvasTmplConfig.call(this,this.shareQrcode),
          )
        );
        if (!this.config.device.isApp) {
          this.maskIsShow = true;
        }
      },
      // 点击x关闭日签
      closeMask() {
        this.maskIsShow = false;
        this.imgSrc = "";
      },
      diseaseShare(){
        this.$axios.get('/api/column_ecosphere/eye_qrcode', {
          params: {
            column_id:this.$route.query.id,
            want_url:encodeURIComponent(config.path.base),
            redirect_url:encodeURIComponent(`/#${this.$route.fullPath}`),
          }
        }).then((res) => {
          let opts = res.data.data;
          this.shareQrcode = opts;
        })
      },
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    activated(){
      if(this.userInfo.phone){
        //登陆了才走二维码页面
        this.diseaseShare();
      }
    }
  }
</script>

<style scoped lang="scss">

  /*以下分享样式*/
  .disease-success {
    .label-area {
      width: rem(286);
      height: rem(508);
      #canvas {
        width: 100%;
        height: 100%;
      }
      #shareImg {
        width: 100%;
        height: 100%;
      }
      .close-icon {
        position: absolute;
        width: rem(30);
        height: rem(30);
        right: rem(10);
        top: rem(10);
        img {
          width: 100%;
        }
      }
    }
  }
  .share{
    width:rem(68);
    right:0;
    bottom:25%;
    z-index:201
  }
</style>